import { mainApi } from "services/main";
import { CreateAuditFormResponse } from "./definitions";
import { Audit } from "models/generateAuditSchemas";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    createAudit: builder.mutation<CreateAuditFormResponse, Audit>({
      query: (request?: Audit) => ({
        url: "audit",
        body: request,
        method: "POST",
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useCreateAuditMutation } = extendedApi;
